import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import JobDetail from "@/pages/JobDetail";
import Plans from "@/pages/Plans";
import Login from "@/pages/Login";
import CompanyDashboard from "@/pages/CompanyDashboard";
import PostJob from "@/pages/PostJob";
import AdminDashboard from "@/pages/AdminDashboard";
import CheckoutResult from "@/pages/CheckoutResult";
import VagaLimpa from "@/pages/VagaLimpa";
import PrimeiroEmprego from "@/pages/PrimeiroEmprego";
import Estagios from "@/pages/Estagios";
import EntrevistaTreino from "@/pages/EntrevistaTreino";
import { Terms, Privacy, Security, Refund, About } from "@/pages/LegalPages";
import { Loader2 } from "lucide-react";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-slate-500"><Loader2 className="animate-spin" size={32} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/" replace />;
  if (role === "company" && user.role !== "company") return <Navigate to="/admin" replace />;
  return children;
}

function Shell({ children }) {
  return <div className="min-h-screen bg-slate-50 flex flex-col"><Navbar /><div className="flex-1">{children}</div><Footer /></div>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/vaga/:id" element={<Shell><JobDetail /></Shell>} />
      <Route path="/vaga-limpa" element={<Shell><VagaLimpa /></Shell>} />
      <Route path="/primeiro-emprego" element={<Shell><PrimeiroEmprego /></Shell>} />
      <Route path="/estagios" element={<Shell><Estagios /></Shell>} />
      <Route path="/entrevista-treino" element={<Shell><EntrevistaTreino /></Shell>} />
      <Route path="/planos" element={<Shell><Plans /></Shell>} />
      <Route path="/login" element={<Shell><Login /></Shell>} />
      <Route path="/termos" element={<Shell><Terms /></Shell>} />
      <Route path="/privacidade" element={<Shell><Privacy /></Shell>} />
      <Route path="/seguranca" element={<Shell><Security /></Shell>} />
      <Route path="/reembolso" element={<Shell><Refund /></Shell>} />
      <Route path="/sobre" element={<Shell><About /></Shell>} />
      <Route path="/checkout/success" element={<Shell><CheckoutResult kind="success" /></Shell>} />
      <Route path="/checkout/pending" element={<Shell><CheckoutResult kind="pending" /></Shell>} />
      <Route path="/checkout/failure" element={<Shell><CheckoutResult kind="failure" /></Shell>} />
      <Route path="/empresa" element={<Protected role="company"><Shell><CompanyDashboard /></Shell></Protected>} />
      <Route path="/empresa/nova-vaga" element={<Protected role="company"><Shell><PostJob /></Shell></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><Shell><AdminDashboard /></Shell></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <BrowserRouter><AuthProvider><Toaster position="top-center" richColors /><AppRouter /></AuthProvider></BrowserRouter>;
}
